import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import signout from '../../queries/3dmssapi/signout'

import { navigate } from '@reach/router'

export default function SignOut(props) {
  const cancel_token = axios.CancelToken.source()

  useEffect(() => {
    return (() => {
      try {
        cancel_token.cancel()
      } catch(error) {
        console.log(error);
      }
    })
  })

  const handleSignout = async (e) => {
    e.preventDefault()

    try {
      await signout(cancel_token)
      props.signOut()

      if (typeof window !== `undefined`) {
        let path = window.location.href
        navigate(path)
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <span onClick={handleSignout}>{props.children}</span>
  )
}

SignOut.propTypes = {
  signOut: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
}